module.exports = __webpack_public_path__ + "static/assets/cc0a95c792fdc42b2b381f34fcdd8a9c.png";